"use strict";
/* eslint-disable */
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));
var _default = (0, _createIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M14.334 19.268v-3.273a.909.909 0 1 1 1.818 0v3.728a1.819 1.819 0 0 1-1.818 1.818H4.788a1.819 1.819 0 0 1-1.818-1.818V4.268c0-1.003.815-1.818 1.818-1.818h9.546c1.003 0 1.818.815 1.818 1.818v3.727a.909.909 0 1 1-1.818 0V4.723a.455.455 0 0 0-.455-.455H5.243a.455.455 0 0 0-.455.455v14.545c0 .251.204.455.455.455h8.636c.251 0 .455-.204.455-.455Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.638 14.673c-.214.214-.535.32-.802.16-.064 0-.128-.038-.18-.08l-.087-.08a.688.688 0 0 1-.214-.534v-.962c0-.107-.107-.214-.213-.213H9.555a.958.958 0 0 1-.962-.962c0-.534.428-.962.962-.962h7.587a.232.232 0 0 0 .214-.214v-.962c0-.214.053-.373.213-.534.321-.32.748-.32 1.069 0l2.137 2.138c.32.32.32.748 0 1.068l-2.137 2.137Z"
})), "0 0 24 24", "Logout");
exports.default = _default;